module.exports = __webpack_public_path__ + "static/media/swing_gitane.7e9324d7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/recordings/swing_gitane.mp3
// module id = 49
// module chunks = 0